import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../data/content';
import { SectionHeading } from './SectionHeading';
import { CTAButton } from './CTAButton';
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full bg-sky px-4 py-14 md:py-20" data-id="element-91" data-mp="1cg1i7pif099g">
      <div className="mx-auto max-w-3xl" data-id="element-92" data-mp="2a2s18655u7v3">
        <SectionHeading title="Frequently asked questions" data-id="element-93" data-mp="2a1h06e33ne7o" />
        <ul className="mt-10 space-y-3" data-id="element-94" data-mp="252w14hzl30kt">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <li key={f.q} className="overflow-hidden rounded-2xl bg-white shadow-sm" data-id="element-95" data-mp="2027z719tgzbt" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center gap-4 p-5 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-teal" data-id="element-96" data-mp="1v4g6w659fb73">
                  <span className="flex-1 text-base font-bold leading-snug text-navy sm:text-lg" data-id="element-97" data-mp="1pmtba2zrhvti">{f.q}</span>
                  <PlusIcon className={`h-6 w-6 shrink-0 text-teal-dark transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-98" data-mp="1apsu2tf75j9a" />
                </button>
                <AnimatePresence initial={false} data-id="element-99" data-mp="11vo0414rnrpj">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} data-id="element-100" data-mp="16oqugbhdb56s">
                      <p className="px-5 pb-5 text-base leading-relaxed text-muted" data-id="element-101" data-mp="iywjjzglzqp6">{f.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
        <CTAButton className="mt-10" label="I'm ready — give me access" subtext="One-time payment · $27 USD" data-id="element-102" data-mp="2pogdtiinssbb" />
      </div>
    </section>;
}